import { render, staticRenderFns } from "./Shopdecoration.vue?vue&type=template&id=b6534fd2&scoped=true"
import script from "./Shopdecoration.vue?vue&type=script&lang=js"
export * from "./Shopdecoration.vue?vue&type=script&lang=js"
import style0 from "./Shopdecoration.vue?vue&type=style&index=0&id=b6534fd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6534fd2",
  null
  
)

export default component.exports